<template>
    <div :class="{ 'has-crossprice': hasCrossPrice }">
        <div class="crossprice" v-if="showCrossPrice && hasCrossPrice">
            <del class="text-muted small text-appearance">
                {{ currentVariation.prices.rrp.unitPrice.formatted | itemCrossPrice }}
            </del>
        </div>

        <div class="single__price-wrapper">
            <div class="single__price price h1">
            <span :content="currentVariation.prices.default.price.value">
            {{ variationTotalPrice | currency(currentVariation.prices.default.currency) }}
        </span>
                <sup>{{ $translate("Ceres::Template.singleItemFootnote1") }}</sup>
                <span :content="currentVariation.prices.default.currency"></span>
            </div>
            <div class="single__price-info">
                <div class="base-price" v-if="currentVariation.unit">
                    <div v-if="currentVariation.variation.mayShowUnitPrice">
                        (<span class="base-price-value">
                        {{ variationGraduatedPrice.basePrice | specialOffer(currentVariation.prices, "basePrice") }}
                    </span>)
                    </div>
                </div>
                <div>
                  <template v-if="isB2b">zzgl.</template><template v-else>inkl.</template> {{ variationGraduatedPrice.vat.value }}% MwSt. zzgl. <a href="https://www.sweets-online.com/content/versand" class="versand-link"><u>Versand</u></a>
                    <slot name="additional-content-after-vat"></slot>
                </div>
            </div>
        </div>

        <!--<span class="price h1">
            <span ref="price">
                <template v-if="showDynamicPrice">
                    {{ $translate("Ceres::Template.dynamicVariationPrice",
                        {
                            price: $options.filters.currency(variationTotalPrice, currentVariation.prices.default.currency)
                        }
                    ) }}
                </template>

                <template v-else>
                    {{ variationTotalPrice | currency(currentVariation.prices.default.currency) }}
                </template>
            </span>
            <sup>*</sup>
        </span>

        <div class="base-price text-muted my-3"
            v-if="currentVariation.unit"
            :class="{ 'is-single-piece': currentVariation.unit && currentVariation.unit.content === 1 && currentVariation.unit.unitOfMeasurement === 'C62' }">
            <div>
                {{ $translate("Ceres::Template.singleItemContent") }}
                <span>{{ currentVariation.unit.content | numberFormat }} </span>
                <span>{{ currentVariation.unit.names.name }}</span>
            </div>
            <div v-if="currentVariation.variation.mayShowUnitPrice">
                {{ $translate("Ceres::Template.singleItemUnitPrice") }}
                <span class="base-price-value">
                    {{ variationGraduatedPrice.basePrice | specialOffer(currentVariation.prices, "basePrice") }}
                </span>
            </div>
        </div>-->

    </div>
</template>

<script>
import { hasVat } from "ceres/app/helper/OrderPropertyHelper";

export default {
    name: "item-price",

    props:
    {
        showCrossPrice:
        {
            type: Boolean,
            default: true
        }
    },

    data(){
      return {
        isB2b: false
      }
    },

    mounted(){
      if(document.querySelector("body").classList.contains("b2b-customer")){
        this.isB2b = true
      }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },

        hasCrossPrice() {
          const hasRrpPrice = !!this.currentVariation.prices.rrp &&
              this.currentVariation.prices.rrp.unitPrice.value > this.currentVariation.prices.default.unitPrice.value;

          const hasBeforePrice = this.hasSpecialOffer &&
              !!this.currentVariation.prices.default &&
              this.currentVariation.prices.default.unitPrice.value > this.currentVariation.prices.specialOffer.unitPrice.value;

          return hasRrpPrice || hasBeforePrice;
        },

        hasSpecialOffer() {
          return !!this.currentVariation.prices.specialOffer;
        },

        variationGraduatedPrice() {
            return this.$store.getters[`${this.itemId}/variationGraduatedPrice`];
        },

        variationTotalPrice() {
            return this.$store.getters[`${this.itemId}/variationTotalPrice`];
        },

        showDynamicPrice() {
            const state = this.$store.state.items[this.itemId];
            return App.config.item.showPleaseSelect && App.isCheapestSorting
                && (state.variationSelect && !state.variationSelect.isVariationSelected)
                && (state.pleaseSelectVariationId === this.currentVariation.variation.id
                    || state.pleaseSelectVariationId === 0);
				},

			propertiesWithAdditionalCostsVisible() {
				return this.currentVariation.properties.filter(entry => {
					const property = entry.property;
					return property && property.isShownAsAdditionalCosts && property.isShownOnItemPage
							&& ((!property.isOderProperty && !App.useVariationOrderProperties)
									|| this.isVariationOrderPropertyRequiredPreselected(property))


				});
			}
		},
		methods: {
			isVariationOrderPropertyRequiredPreselected(property) {
				return property.isRequired
						&& property.isPreSelected
						&& property.isOderProperty
						&& App.useVariationOrderProperties
			},

			hasTax(property)
			{
				return hasVat(property);
					}
			}
	}

</script>
